import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <span className="logo-mark">Y</span> Yishak<span className="logo-dot">.</span>
          </div>
          <p className="footer-tagline">
            Full Stack Developer crafting fast, beautiful products for web & mobile.
          </p>
          <div className="footer-social">
            <a href="https://www.linkedin.com/in/yishak-hailu" target="_blank" rel="noreferrer" aria-label="LinkedIn">in</a>
            <a href="https://www.instagram.com/_y.i.s.h.a.k_/" target="_blank" rel="noreferrer" aria-label="Instagram">ig</a>
            <a href="https://t.me/iamyishakg" target="_blank" rel="noreferrer" aria-label="Telegram">tg</a>
          </div>
        </div>

        <div className="footer-links">
          <div className="fl-col">
            <h4>Navigate</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="fl-col">
            <h4>Social</h4>
            <ul>
              <li><a href="https://www.linkedin.com/in/yishak-hailu" target="_blank" rel="noreferrer">LinkedIn</a></li>
              <li><a href="https://t.me/iamyishakg" target="_blank" rel="noreferrer">Telegram</a></li>
              <li><a href="https://www.instagram.com/_y.i.s.h.a.k_/" target="_blank" rel="noreferrer">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-cta">
          <h4>Send me a message</h4>
          <p>I'll get back to you within a few hours.</p>
          <form onSubmit={(e) => e.preventDefault()}>
            <label className="sr-only" htmlFor="f-email">Email</label>
            <input id="f-email" type="email" placeholder="Your email" required />
            <label className="sr-only" htmlFor="f-msg">Message</label>
            <textarea id="f-msg" placeholder="Tell me about your idea..." required />
            <button type="submit">Send message →</button>
          </form>
        </div>
      </div>
    </footer>
  );
}
